module.exports = __webpack_public_path__ + "static/img/mediaCompany.7e499c2b.png";